import { PLACEHOLDERS, placeholderStyle } from "@shared/unified-tiptap/placeholders"
import { SECTION_COLOR_MAP } from "@shared/util/colors"
import type { ExtensionCardTitleAttrs } from "@tiptap-content/extensions/card-title/card-title-content-extension"
import { NodeViewContent, NodeViewWrapper, type ReactNodeViewProps } from "@tiptap/react"

export const CardTitleComponent = ({ node }: Pick<ReactNodeViewProps, "node">) => {
  const attrs = node.attrs as ExtensionCardTitleAttrs

  // min-w keeps a click target & room for the "Title" placeholder when empty. A long word
  // breaks at the row edge instead of overflowing; hyphens-auto upgrades that to a real
  // hyphen where supported.
  const titleClassName =
    "block min-h-[1.125rem] min-w-[50px] text-[1.125rem] font-bold break-words hyphens-auto leading-tight"

  return (
    <NodeViewWrapper className="select-none" data-content-type="cardTitle" data-color={attrs.color}>
      <NodeViewContent<"span">
        as="span"
        className={titleClassName}
        style={{
          color: SECTION_COLOR_MAP[attrs.color],
          ...placeholderStyle(PLACEHOLDERS.cardTitle),
        }}
      />
    </NodeViewWrapper>
  )
}
